import { render, staticRenderFns } from "./LocalFiles.vue?vue&type=template&id=11ccfaf2"
import script from "./LocalFiles.vue?vue&type=script&lang=js"
export * from "./LocalFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports